/** @param {Ref<string> | string} maybeRefTitle */
export const useCustomTitle = maybeRefTitle => {
  const title = unref(maybeRefTitle);
  useTitle(`${title} | COCOO`);
};